import { jsx as o } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import { createSvgIcon as w } from "@mui/material/utils";
const i = () => /* @__PURE__ */ o("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ o(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 12.17 8.83 9l-1.41 1.41L12 15l4.59-4.59L15.17 9z",
    clipRule: "evenodd"
  }
) }), s = w(i(), "ArrowDown");
function f({ width: r, height: n, sx: e, ...l }, t) {
  return /* @__PURE__ */ o(
    s,
    {
      ref: t,
      viewBox: "0 0 24 24",
      sx: {
        width: r,
        height: n || r,
        ...e
      },
      ...l
    }
  );
}
const d = c(f);
export {
  d as A
};
